import React from 'react';

import { FlowComponentType } from 'routes/types';
import Button, { ButtonType } from 'components/Button';
import FinancialCheckupNavigation from 'components/FinancialCheckup/FinancialDashboardNavigation';
import ShiftsList from 'components/FinancialCheckup/ShiftsList';
import { useAvailableShifts } from 'components/FinancialCheckup/FinancialDashboard/AvailableShiftsSection/useAvailableShifts';

import AvailabilityCalendar from './AvailabilityCalendar';
import { useShiftCalendarLogic } from './useShiftCalendarLogic';

import styles from './AvailableShifts.module.scss';

const AvailableShifts = ({ navigationInfo }: FlowComponentType): JSX.Element => {
  const { shifts, isLoading } = useAvailableShifts();

  const {
    selectedDate,
    filteredShifts,
    availableDateKeys,
    hasRemainingShifts,
    handleDateSelect,
    handleMonthChange,
    handleShowMore,
    handleSeeAll,
  } = useShiftCalendarLogic(shifts);

  const hasShifts = shifts.length > 0;

  const renderContent = () => {
    if (isLoading) {
      return <p className={styles.centeredText}>Loading shifts...</p>;
    }

    if (!hasShifts) {
      return <p className={styles.centeredText}>No shifts available</p>;
    }

    return (
      <>
        <AvailabilityCalendar
          heading="Shifts can change fast. Check Shift Wizard to see what’s available and sign up in real time."
          selectedDate={selectedDate}
          availableDateKeys={availableDateKeys}
          onDateSelect={handleDateSelect}
          onMonthChange={handleMonthChange}
        />
        <div className={styles.listContainer}>
          {filteredShifts.length > 0 ? (
            <ShiftsList shifts={filteredShifts} />
          ) : (
            <p className={styles.centeredText}>
              {selectedDate ? 'No shifts available for this date' : 'No shifts available this week'}
            </p>
          )}
        </div>
        {selectedDate && (
          <Button type={ButtonType.Transparent} onClick={handleSeeAll} className={styles.seeAllButton}>
            See all
          </Button>
        )}
        {hasRemainingShifts && (
          <Button type={ButtonType.Transparent} onClick={handleShowMore} className={styles.showMoreButton}>
            See more
          </Button>
        )}
      </>
    );
  };

  return (
    <>
      <FinancialCheckupNavigation {...navigationInfo} />
      <div className={styles.content}>{renderContent()}</div>
    </>
  );
};

export default AvailableShifts;
